import { createAction } from '@reduxjs/toolkit';

export const resetPassword = createAction<string>('RESET_PASSWORD');
